// Entry point for the build script in your package.json

// Stimulus
import { Application } from "@hotwired/stimulus";
import HeaderController from "./controllers/HeaderController";
import ScheduleEventsController from "./controllers/ScheduleEventsController";
const application = Application.start();
application.register("header", HeaderController);
application.register("schedule-events", ScheduleEventsController);
